import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  private currentLocale: string = 'en';

  constructor() {}

  getCurrentLocale(): string {
    return this.currentLocale;
  }

  setLocale(locale: string) {
    this.currentLocale = locale;
    // Add any additional logic for language change
  }
} 